import React, { Component, Fragment } from "react";
import { compose, graphql } from "react-apollo";
import { Col, Row } from "reactstrap";
import { AvField } from "availity-reactstrap-validation";
import { Typography } from "@material-ui/core";
import Select from "react-select";
import moment from "moment";

import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import "./SearchBar.css";

import HeroHoteles from "../../assets/img/hero/hero-hoteles.webp";
import HeroReady2Go from "../../assets/img/hero/hero-ready2go.webp";
import HeroCruceros from "../../assets/img/hero/hero-cruceros.webp";
import HeroCarros from "../../assets/img/hero/hero-carros.webp";

import Keywords from "../../queries/Keywords";
import NewSearch from "../../mutations/NewSearch";
import Promo from "../Promo/Promo";
import HomePromo from "../HomePromo/HomePromo";
import HomePromoWide from "../HomePromoWide/HomePromoWide";
import Crucero from "../Crucero/Crucero";

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchString: "",
      arrival: new Date(Date.now() - 12096e5),
      departure: new Date(Date.now() + 12096e5),
      adults: 0,
      children: 0, //false
      childrenAmount: 1,
      editChildren: false,
      childrenTxtBoxes: [0, 0, 0, 0],
      vacationType: 0,
      keywordsCount: 1,
      keywords: [],
    };
    this.adultsSelect = React.createRef();
  }

  renderOptions(num) {
    let options = [];
    for (let i = 1; i < num + 1; i++) {
      options.push(
        <option value={i} key={i}>
          {i}
        </option>
      );
    }
    return options;
  }

  handleChildrenValue(num, value) {
    let childrenTxtBoxes = this.state.childrenTxtBoxes;
    value = value !== null ? parseInt(value) : 0;
    childrenTxtBoxes[num] = value;
    this.setState({ childrenTxtBoxes });
  }

  handleChildrenChange(value) {
    value = JSON.parse(value); // turn the string "true"|"false" into boolean
    if (value) {
      this.setState({
        children: value,
      });
    } else {
      this.setState({
        children: value,
        childrenTxtBoxes: [],
      });
    }
  }

  addChildren() {
    let childrenAmount = this.state.childrenAmount;
    if (childrenAmount >= 1 && childrenAmount < 4) {
      childrenAmount = childrenAmount + 1;
    }
    this.setState({ childrenAmount });
  }

  removeChildren() {
    let childrenAmount = this.state.childrenAmount;
    if (childrenAmount > 1 && childrenAmount <= 4) {
      childrenAmount = childrenAmount - 1;
    }
    this.setState({ childrenAmount });
  }

  renderChildren() {
    let textBoxes = [];
    let childrenAmount = this.state.childrenAmount;
    for (let i = 1; i <= childrenAmount; i++) {
      textBoxes.push(
        <Fragment key={`${i}`}>
          <Typography key={`title-${i}`} variant="overline">{`¿Cuantos años tiene?`}</Typography>
          <AvField
            key={`field-${i}`}
            name={`child-${i}`}
            type="number"
            value={this.state.childrenTxtBoxes[i - 1]}
            onChange={(e) => this.handleChildrenValue(i - 1, e.target.value)}
            validate={{
              required: { value: true, errorMessage: "Favor de poner una edad" },
              min: { value: 1, errorMessage: "El minimo de edad es 1 año" },
              max: { value: 17, errorMessage: "Su hijo tiene que ser menor de 18 años" },
            }}
          />
        </Fragment>
      );
    }
    return textBoxes;
  }

  saveSearched(keywords) {
    keywords.map((keyword) => {
      return this._newSearch(keyword.value);
    });
  }

  startSearch() {
    const {
      arrival,
      adults,
      departure,
      children,
      childrenAmount,
      childrenTxtBoxes,
      keywords,
      vacationType,
    } = this.state;
    let searchString;
    keywords.map((key, index) =>
      index === 0 ? (searchString = `${key.label} `) : (searchString += `${key.label} `)
    );
    const emptyStringPlaceholder = "123456789!";
    let formatArrival = moment(arrival).format("MM-DD-YYYY");
    let formatDeparture = moment(departure).format("MM-DD-YYYY");
    let childrenX = [children, childrenAmount, childrenTxtBoxes];
    this.saveSearched(keywords);
    return this.props.history.push(
      `/searchResult/${
        searchString ? searchString : emptyStringPlaceholder
      }/${formatArrival}/${formatDeparture}/${adults}/${childrenX}/500,10000/${vacationType}`
    );
  }
  ready2goSearch() {
    const { adults, children, childrenAmount, childrenTxtBoxes, vacationType } = this.state;
    let searchString = "ready2go";
    let formatArrival = moment().format("MM-DD-YYYY");
    let formatDeparture = moment().add(12, "months").format("MM-DD-YYYY");
    let childrenX = [children, childrenAmount, childrenTxtBoxes];
    return this.props.history.push(
      `/searchResult/${searchString}/${formatArrival}/${formatDeparture}/${adults}/${childrenX}/500,10000/${vacationType}`
    );
  }

  renderKeywords() {
    const { keywordsQ } = this.props;
    if (keywordsQ.loading) {
      return <div>Loading Keywords...</div>;
    }
    let dataKeywords = this.state.keywords.map((keyword) => {
      return { label: keyword.keyword, value: keyword.id };
    });
    const keywords = keywordsQ.keywords;
    let maxKeyWords = this.state.keywordsCount;
    let keywordsData = [];
    let keywordState = "keywordText" + maxKeyWords;
    let keywordStateObj = {
      label: this.state[keywordState],
      value: maxKeyWords,
    };
    let keywordLabels = [];
    keywords.map((keyword) => {
      if (!keywordLabels.includes(keyword.keyword)) {
        keywordLabels.push(keyword.keyword);
        keywordsData.push({ label: keyword.keyword, value: keyword.id });
      }
      return null;
    });
    let labels = keywordsData.map((key) => {
      return key.label;
    });
    if (!labels.includes(keywordStateObj.label)) {
      keywordsData.push(keywordStateObj);
    }
    return (
      <Select
        className="w-100 text-left searchbox"
        options={this.state[keywordState] ? keywordsData : []}
        noOptionsMessage={() => null}
        placeholder="Busqueda..."
        value={this.state.keywords ?? dataKeywords}
        onChange={(keywords) => {
          this.setState({
            keywords,
            keywordsCount: this.state[keywordState] ? maxKeyWords + 1 : maxKeyWords,
          });
        }}
        onInputChange={(keywordText) => this.setState({ [keywordState]: keywordText })}
        isMulti
      />
    );
  }

  handleCrucero() {
    window.open(
      "https://book.aatours.com/swift/cruise?advancedsearch=true&siid=1053733&lang=4",
      "_blank"
    );
  }

  handleHoteles() {
    window.open("https://book.aatours.com/web/hotel/default.aspx", "_blank");
  }

  handleCarros() {
    window.open("https://abglac.com/aatours", "_blank");
  }

  render() {
    return (
      <div className="hero-area">
        <div className="hero-centered">
          <h1 className="hero-title-top">MÁS QUE VIAJES,</h1>
          <h2 className="hero-title-bottom">CREAMOS EXPERIENCIAS</h2>
          <p className="hero-subtitle">
            Ahora puedes crear tu propio itinerario completamente personalizado a tus necesidades
            con solo unos cuantos pasos, escoger de ofertas preparadas a los destinos más cotizados
            o escoger en qué crucero te quieres ir.
            <br />
            <span className="hero-click" onClick={() => this.handleCrea()}>
              ¡VIAJAR NUNCA HA SIDO TAN FÁCIL!
            </span>
          </p>
          {/* <Button color="primary" className="ml-3 hero-btn" onClick={() => this.handleCrea()}>
            CREA TU PROPIO VIAJE
          </Button> */}
          <div className="hero-blocks">
            <Row>
              <Col lg="3" md="12" sm="12" xs="12">
                <Crucero image={HeroCruceros} />
              </Col>
              <Col lg="3" md="12" sm="12" xs="12">
                <HomePromo
                  type="RTOGO"
                  image={HeroReady2Go}
                  title="PAQUETE GRUPAL"
                  subtitle="Paquetes ya preparados para ir con grupos a los destinos. Viaja el mundo con A&A
                  Tours."
                  click={() => this.ready2goSearch()}
                />
              </Col>
              <Col lg="3" md="12" sm="12" xs="12">
                <HomePromo
                  type="HOTELES"
                  image={HeroHoteles}
                  title="RESERVA TU HOTEL"
                  subtitle="Escoge y compara tus Hoteles preferidos en los destinos que visitas."
                  click={() => this.handleHoteles()}
                />
              </Col>
              <Col lg="3" md="12" sm="12" xs="12">
                <Promo />
              </Col>
            </Row>
            <Row>
              <Col lg="12" className="text-center mt-3">
                <HomePromoWide
                  type="CARROS"
                  image={HeroCarros}
                  title="ALQUILA TU CARRO"
                  click={() => this.handleCarros()}
                />
              </Col>
            </Row>
          </div>
          {/* <div className="searchRow">
            <Row className="w-100">
              <Col lg="6" md="12" sm="12">
                {!this.props.keywordsQ.loading && this.renderKeywords()}
              </Col>
              <Col className="arrivalCol" lg="3" md="6" sm="6" xs="6">
                <div className="date-container">
                  <Typography className="searchBarLbl">Check-In</Typography>
                  <DatePicker
                    className="arrival"
                    minDate={moment().toDate()}
                    value={this.state.arrival}
                    onChange={(e) => this.setState({ arrival: e })}
                    clearIcon={null}
                  />
                </div>
              </Col>
              <Col className="departureCol" xl="3" lg="6" md="6" sm="6" xs="6">
                <div className="date-container">
                  <Typography className="searchBarLbl">Check-Out</Typography>
                  <DatePicker
                    className="departure"
                    value={this.state.departure}
                    minDate={moment().toDate()}
                    onChange={(e) => this.setState({ departure: e })}
                    clearIcon={null}
                  />
                </div>
              </Col>

              <Col className="text-center mt-3" lg="12">
                <Button color="primary" className="hero-btn" onClick={() => this.startSearch()}>
                  BÚSQUEDA DE PAQUETES
                </Button>
              </Col>
            </Row>

            <Modal
              open={this.state.editChildren}
              onClose={() => this.setState({ editChildren: false })}
            >
              <Card>
                <CardBody className="text-center">
                  <Row>
                    <Col>
                      <Typography variant="overline">¿Tiene hijos?</Typography>
                      <Input
                        type="select"
                        value={this.state.children}
                        style={{ textIndent: "calc(95%/2)" }}
                        className="searchChildren formControlFix searchInputBorder"
                        onChange={(e) => this.handleChildrenChange(e.target.value)}
                      >
                        <option value={false}>No</option>
                        <option value={true}>Sí</option>
                      </Input>
                      <AvForm style={{ visibility: this.state.children ? "visible" : "hidden" }}>
                        <Row className="child-container flex w-100">
                          <Button
                            onClick={() => {
                              this.removeChildren();
                            }}
                          >
                            <Remove />
                          </Button>
                          <Button disabled>{`${this.state.childrenAmount} de 4`}</Button>
                          <Button
                            onClick={() => {
                              this.addChildren();
                            }}
                          >
                            <Add />
                          </Button>
                        </Row>
                        {this.renderChildren()}
                      </AvForm>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Modal>
          </div> */}
        </div>
      </div>
    );
  }

  _newSearch = async (keywordId) => {
    let { newSearch } = this.props;
    let variables = { keywordId };
    await newSearch({ variables });
  };
}

export default compose(
  graphql(Keywords, { name: "keywordsQ" }),
  graphql(NewSearch, { name: "newSearch" })
)(SearchBar);
